import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { take } from 'rxjs/operators';

/**
 * Centralized audit logging for the frontend.
 * Uses DataService for the audit API and current user state; components call submitAuditLog(activity) only.
 */
@Injectable({
  providedIn: 'root',
})
export class AuditService {
  constructor(private dataService: DataService) {}

  /**
   * Submits an audit log entry for the current user.
   * No-op if current user is not available (e.g. not yet loaded).
   */
  submitAuditLog(activity: string): void {
    this.dataService.currentUser$
      .pipe(take(1))
      .subscribe((user) => {
        if (user?.intUserPK != null) {
          this.dataService.addAuditLog(activity, user.intUserPK).subscribe(() => {});
        }
      });
  }
}
